WiseMetering.Permissions = {
    features: {
        advancedAlarms: { create: 'superUser', read: 'standard', update: 'administrator', delete: 'forbidden' },
        circuitTypes: { create: 'manager', read: 'standard', update: 'manager', delete: 'manager' },
        companies: { create: 'standard', read: 'standard', update: 'standard', delete: 'standard' },
        complexIndicators: { create: 'superUser', read: 'standard', update: 'superUser', delete: 'superUser' },
        costs: { create: 'superUser', read: 'standard', update: 'superUser', delete: 'superUser' },

        customDashboard: { create: 'administrator', read: 'standard', update: 'administrator', delete: 'administrator' },

        devices: { create: 'forbidden', read: 'standard', update: 'forbidden', delete: 'forbidden' },
        etlIndicators: { create: 'manager', read: 'standard', update: 'manager', delete: 'manager' },
        events: { create: 'superUser', read: 'standard', update: 'manager', delete: 'manager' },
        globalDashboard: { create: 'manager', read: 'standard', update: 'manager', delete: 'manager' },
        globalIndicators: { create: 'manager', read: 'manager', update: 'manager', delete: 'manager' },
        globalReports: { create: 'manager', read: 'standard', update: 'manager', delete: 'manager' },
        groups: { create: 'superUser', read: 'standard', update: 'superUser', delete: 'superUser' },
        importIndicators: { create: 'manager', read: 'standard', update: 'forbidden', delete: 'manager' },
        integrationLicenses: { create: 'superUser', read: 'administrator', update: 'superUser', delete: 'superUser', request: 'administrator' },
        invoices: { create: 'manager', read: 'standard', update: 'manager', delete: 'manager' },
        markers: { create: 'manager', read: 'standard', update: 'manager', delete: 'manager' },
        mirrorIndicators: { create: 'manager', read: 'standard', update: 'administrator', delete: 'manager' },
        objectives: { create: 'manager', read: 'standard', update: 'forbidden', delete: 'manager' },
        opportunities: { create: 'manager', read: 'standard', update: 'forbidden', delete: 'manager' },
        organizations: { create: 'manager', read: 'manager', update: 'manager', delete: 'manager' },
        plans: { create: 'forbidden', read: 'standard', update: 'administrator', delete: 'forbidden' },
        rawIndicators: { create: 'manager', read: 'standard', update: 'manager', delete: 'manager' },
        regularAlarms: { create: 'administrator', read: 'standard', update: 'administrator', delete: 'administrator' },
        reports: { create: 'administrator', read: 'standard', update: 'forbidden', delete: 'administrator' },
        scheduledReports: { create: 'administrator', read: 'standard', update: 'administrator', delete: 'administrator' },
        sites: { create: 'superUser', read: 'standard', update: 'superUser', delete: 'forbidden' },
        sitesActivation: { create: 'superUser', read: 'superUser', update: 'superUser', delete: 'superUser' },
        sitesDetails: { create: 'manager', read: 'manager', update: 'manager', delete: 'manager' },
        sitesManagement: { create: 'manager', read: 'manager', update: 'manager', delete: 'manager' },
        siteTags: { create: 'administrator', read: 'administrator', update: 'administrator', delete: 'administrator' },
        tariffs: { create: 'forbidden', read: 'standard', update: 'forbidden', delete: 'forbidden' },
        templateAlarms: { create: 'superUser', read: 'administrator', update: 'superUser', delete: 'superUser' },
        tenants: { create: 'manager', read: 'standard', update: 'manager', delete: 'manager' },
        users: { create: 'administrator', read: 'standard', update: 'forbidden', delete: 'administrator' },
        zoneAttributes: { create: 'administrator', read: 'standard', update: 'forbidden', delete: 'administrator' },
        zonePermissions: { create: 'superUser', read: 'superUser', update: 'superUser', delete: 'superUser' }, // added, is it correct?
        //integrations:
        contazara: { create: 'administrator', read: 'standard', update: 'administrator', delete: 'superUser', disable: 'administrator' },
        dataPortal: { create: 'administrator', read: 'standard', update: 'administrator', delete: 'superUser', disable: 'administrator' },
        datelka: { create: 'superUser', read: 'standard', update: 'forbidden', delete: 'superUser', disable: 'superUser' },
        degreeDays: { create: 'forbidden', read: 'forbidden', update: 'forbidden', delete: 'forbidden', disable: 'forbidden' },
        eRedes: { create: 'administrator', read: 'standard', update: 'administrator', delete: 'superUser', disable: 'administrator' },
        electricityMaps: { create: 'administrator', read: 'standard', update: 'administrator', delete: 'superUser', disable: 'administrator' },
        infraspeak: { create: 'superUser', read: 'standard', update: 'superUser', delete: 'superUser', disable: 'superUser' },
        measurabl: { create: 'superUser', read: 'standard', update: 'superUser', delete: 'superUser', disable: 'superUser' },
        navigator: { create: 'administrator', read: 'standard', update: 'administrator', delete: 'superUser', disable: 'administrator' },
        nextbittData: { create: 'superUser', read: 'standard', update: 'superUser', delete: 'superUser', disable: 'superUser' },
        shopperTrak: { create: 'superUser', read: 'standard', update: 'forbidden', delete: 'administrator', disable: 'superUser' },
        v2Charge: { create: 'administrator', read: 'standard', update: 'administrator', delete: 'superUser', disable: 'administrator' },
        waterbeep: { create: 'superUser', read: 'standard', update: 'superUser', delete: 'superUser', disable: 'superUser' },
        weatherApi: { create: 'forbidden', read: 'forbidden', update: 'forbidden', delete: 'forbidden', disable: 'forbidden' },
        // TBA
        luzboa: { create: 'forbidden', read: 'forbidden', update: 'forbidden', delete: 'forbidden', disable: 'forbidden' },
        fusionSolar: { create: 'forbidden', read: 'forbidden', update: 'forbidden', delete: 'forbidden', disable: 'forbidden' },
        manttest: { create: 'forbidden', read: 'forbidden', update: 'forbidden', delete: 'forbidden', disable: 'forbidden' },
        nextbittMaintenance: { create: 'forbidden', read: 'forbidden', update: 'forbidden', delete: 'forbidden', disable: 'forbidden' }
    },

    plans: {
        alarms: 'free',
        dataAnalysis: 'free',
        circuits: 'free',  // added to work with root_objects/views/show.js noAccessView()
        computedIntegrations: 'advanced',
        companies: 'advanced',
        freeReports: 'free',
        folders: 'free',  // added to work with root_objects/views/show.js noAccessView()
        iso50001: 'advanced',
        mappedIntegrations: 'standard',
        markers: 'standard',
        objectives: 'standard',
        opportunities: 'standard', // should it be essentials/free?
        premiumReports: 'premium',
        rawIntegrations: 'free',
        seus: 'advanced',
        standardReports: 'standard',
        tariffs: 'free',   // added tariffs for clarity, following the same permission as utilities (was previously standard)
        tenants: 'advanced',
        utilities: 'free',
        zones: 'free'   // added to work with root_objects/views/show.js noAccessView()
    },

    planValues: {
        premium: 5,
        advanced: 4,
        standard: 3,
        essentials: 2,
        free: 1
    },

    hasIntegrationPermissions: function(planSlug) {
        const
            currentPlan = WiseMetering.Permissions.planValues[WiseMetering.currentOrganization.plan().get('slug')] || 0,
            integrationMinValue = WiseMetering.Permissions.planValues[planSlug] || 0;

        return currentPlan >= integrationMinValue;
    },

    hasRolePermissions: function(resource, action = 'read') {
        const lowestAccessRole = WiseMetering.Permissions.features[resource]?.[action] || 'forbidden';

        if (lowestAccessRole === 'forbidden') {
            return false;
        }

        const methodName = 'is' + lowestAccessRole.charAt(0).toUpperCase() + lowestAccessRole.slice(1); // e.g. isSuperUser

        return WiseMetering.currentUser[methodName] && WiseMetering.currentUser[methodName]();
    },

    hasPlanPermissions: function(resource) {
        const
            currentPlan = WiseMetering.Permissions.planValues[WiseMetering.currentOrganization.plan().get('slug')] || 0,
            resourceMinValue = WiseMetering.Permissions.planValues[WiseMetering.Permissions.plans[resource]] || 5;

        return currentPlan >= resourceMinValue;
    }
};
